import { useAtomValue } from 'jotai';
import { simInventoryUrlParamsAtom } from 'src/atoms/filters/sim';
import { Routes } from 'src/Routes.constants';

export const useSimProfilesUrlFromFilters = () => {
  const urlParams = useAtomValue(simInventoryUrlParamsAtom);

  return `${Routes.simInventory}?${urlParams}`;
};
